"use strict";
var DISTRICT_ADMIN_PERMISSION = "admin_test_prep_settings_district";
var SCHOOL_ADMIN_PERMISSION = "admin_test_prep_settings";
var CurrentUser = (function () {
    function CurrentUser(user) {
        this.lastName = user.lastName;
        this.userId = user.userId;
        this.tenantId = user.tenantId;
        this.permissions = user.permissions;
        this.firstName = user.firstName;
        this.districtUser = user.districtUser;
        this.preferences = user.preferences;
    }
    CurrentUser.prototype.hasPermission = function (permission) {
        return this.permissions.some(function (permItem) { return permItem === permission; });
    };
    CurrentUser.prototype.isSchoolAdmin = function () { return this.hasPermission(SCHOOL_ADMIN_PERMISSION); };
    CurrentUser.prototype.isDistrictAdmin = function () { return this.hasPermission(DISTRICT_ADMIN_PERMISSION); };
    CurrentUser.prototype.isAdmin = function () { return this.isSchoolAdmin() || this.isDistrictAdmin(); };
    return CurrentUser;
}());
exports.CurrentUser = CurrentUser;



/** WEBPACK FOOTER **
 ** ./app/models/user/user.model.ts
 **/